var _circle, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPhone1(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 35,
    viewBox: "0 0 35 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 17.235,
    cy: 17.235,
    r: 17.235,
    fill: "#CB202D"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.1613 10.8924L14.8745 10.6644C15.544 10.451 16.258 10.7963 16.545 11.4711L17.1144 12.8155C17.3623 13.4008 17.2251 14.0895 16.7737 14.5178L15.5182 15.7096C15.5951 16.4229 15.835 17.1249 16.2367 17.8156C16.6184 18.4839 17.1303 19.0689 17.7422 19.5358L19.2502 19.032C19.8223 18.8418 20.4447 19.0612 20.7947 19.5762L21.6121 20.7761C22.0197 21.3753 21.9468 22.2013 21.4411 22.709L20.8988 23.2533C20.3592 23.7948 19.5883 23.9917 18.8757 23.769C17.1926 23.244 15.6455 21.6855 14.2335 19.0937C12.8196 16.4978 12.3204 14.2944 12.7367 12.486C12.9117 11.725 13.4533 11.1185 14.1613 10.8924Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhone1);
export default __webpack_public_path__ + "static/media/Phone1.72feae083a6dc7ca272bb181ac10ce71.svg";
export { ForwardRef as ReactComponent };